import type { PlayerState } from "@grundbesitz/shared";
import { TokenIcon } from "../board/TokenIcon";
import { Button } from "../ui/Button";
import { colorHex, formatMoney } from "../../lib/format";

/** The winner, large: token, name and why the game ended. */
export function WinnerHero({
  winner,
  isYou,
  reason,
  worth,
  turns,
  onLeave,
}: {
  winner: PlayerState | null;
  isYou: boolean;
  reason: string | null;
  worth: number;
  turns: number;
  onLeave: () => void;
}) {
  const hex = colorHex(winner?.color);
  return (
    <section aria-labelledby="winner-title" className="overflow-hidden rounded-2xl border border-line bg-surface">
      <div className="h-2.5" style={{ background: winner ? hex : "var(--line)" }} aria-hidden="true" />
      <div className="flex flex-col items-start gap-6 p-6 sm:flex-row sm:items-center sm:gap-10 sm:p-10">
        {winner && (
          <span
            className="grid size-28 shrink-0 place-items-center rounded-full border-[6px] bg-surface-2 sm:size-36"
            style={{ borderColor: hex }}
          >
            <TokenIcon token={winner.token} color={winner.color} size={84} title={winner.name} />
          </span>
        )}
        <div className="min-w-0">
          <h1 id="winner-title" className="font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink [overflow-wrap:anywhere] sm:text-6xl">
            {winner ? (isYou ? "Du hast gewonnen" : `${winner.name} hat gewonnen`) : "Das Spiel ist beendet"}
          </h1>
          {reason && <p className="mt-3 text-lg font-medium text-ink">{reason}</p>}
          {winner && (
            <p className="mt-1 text-ink-2">
              Vermögen {formatMoney(worth)} nach {turns.toLocaleString("de-DE")} {turns === 1 ? "Zug" : "Zügen"}
            </p>
          )}
          <Button variant="primary" className="mt-6 min-h-12 px-6 text-base" onClick={onLeave}>
            Zur Startseite
          </Button>
        </div>
      </div>
    </section>
  );
}
